<template>
  <div
    v-loading="isDataLoading"
    class="affiliate-offers"
  >
    <AddOfferPopup
      v-show="isPopupOpen"
      v-model:customer-currencies="customerCurrencies"
      v-model:currency="defaultCurrency"
      :is-open="isPopupOpen"
      :action="action"
      :data="data"
      :affiliate="affiliateId"
      :offers-catalog="offersCatalog"
      :offer-permissions="linksOfferPermissions"
      :permissions="permissions"
      @close="onClosePopup"
    />
    <PendingChanges
      v-show="isPendingPopupOpen"
      :is-open="isPendingPopupOpen"
      :offer-info="offerInfo"
      :is-data-loading="isDataLoading"
      :is-edit-offer="isEditOffer"
      @close="onClosePendingPopup"
      @cancel-scheduled-changes="cancelScheduledChanges(offerInfo.id)"
    />
    <OfferDeleteConfirm
      v-show="isPopupOpenConfirm"
      :is-open="isPopupOpenConfirm"
      :data="offerInfo"
      @unpin="deleteOffer"
      @close="onClosePopupConfirm"
    />
    <UiConfirm
      ref="confirm"
      class="affiliate-offers-new__confirm"
      :width="480"
      :loading-action="loadingBtnConfirm"
      :type="confirmType"
      :action-name="actionName"
      :action="confirmAction"
      :action-icon="actionIcon"
      :action-fa-icon="actionFaIcon"
      @close="closeConfirmHandler"
      @save="confirmHandler"
    >
      <template v-slot:title>
        <div v-html="confirmTitle" />
      </template>

      <div class="body__wrap">
        <i
          :class="confirmType"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <div
          class="body__msg"
          v-html="confirmMsg"
        />
      </div>
    </UiConfirm>
    <div class="wrapper">
      <div class="info">
        <div class="blocks-left">
          <div class="blocks-left__header">
            <div
              v-if="isCreateOfferLinkedToCatalog"
              class="links-catalog-offer__select"
            >
              <UiButton
                size="big"
                class="edit-btn offer-card offer-card__mini"
                @click="openLinkCatalogSelect"
              >
                <div class="links-catalog-offer__header">
                  <UiIcon
                    name="list"
                    color="#212529"
                  />
                  <span>{{ $t('affiliates.affiliatesOffers.add_from_catalog') }}</span>
                  <i
                    v-if="offersCatalog.length > 1 && isCatalogOfferSelectOpen"
                    class="ui-chevron far fa-angle-up chevron"
                  />
                  <i
                    v-if="offersCatalog.length > 1 && !isCatalogOfferSelectOpen"
                    class="ui-chevron far fa-angle-down chevron"
                  />
                </div>
              </UiButton>
              <UiSelectElement
                ref="select_link_catalog"
                filterable
                size="big"
                class="links-catalog-offer__select_hidden"
              >
                <template v-slot:options>
                  <ElOptionGroup
                    v-for="category in offersCatalogGrouped"
                    :key="category.category_id"
                    class="filter-select-group"
                    :label="category.category_name"
                  >
                    <ElOption
                      v-for="offer in category.offers"
                      :key="`${offer.category_id}-${offer.id}`"
                      :label="offer.name"
                      :value="`${offer.category_id}-${offer.id}`"
                      @click="linkOffer(offer)"
                    />
                  </ElOptionGroup>
                </template>
              </UiSelectElement>
            </div>
            <UiButton
              v-if="isCreateOfferCustom"
              class="edit-btn offer-card offer-card__mini"
              size="big"
              @click="addOffer()"
            >
              + {{ $t('affiliates.cardView.toolbar.btns.custom') }}
            </UiButton>
          </div>
          <div v-if="isOfferLoading && affiliateOffersList.length !== 0">
            <div
              v-for="(item, index) in affiliateOffersList"
              :key="index"
              :class="{ 'offer-card__active': isActiveOfferCard === index }"
              class="offer-card offer-card__mini"
              @click="activeOffer(item.id, index)"
            >
              <div>
                <UiIcon
                  :name="item.cataloged_affiliate_offer_id ? 'list' : 'gear'"
                  substyle="far"
                  color="#6c757d"
                />
                <span class="text-fade t:ml-4">ID: {{ item.incrementing_id }}</span>
                <h5 class="offer-card__title-inner">
                  {{ item.name }}
                </h5>
              </div>
              <span
                v-if="item.scheduled_changes_effective_timestamp !== null"
                class="offer-card__pending-offer"
                @click="pendingChangesPopup()"
              >
                {{ $t('affiliates.affiliatesOffers.pand_change') }}
              </span>
            </div>
          </div>
        </div>
        <!-- .......right -->
        <OfferInfo
          :is-offer-loading="isOfferLoading"
          :is-list="affiliateOffersList.length !== 0"
          :is-edit-offer="isEditOffer"
          :is-delete-offer="isDeleteOffer"
          :loading-btn="loadingBtn"
          :offer-info="offerInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddOfferPopup from '@/components/Popups/AddOfferPopup.vue';
import PendingChanges from '@/components/Popups/PendingChanges.vue';
import OfferDeleteConfirm from '@/components/Popups/OfferDeleteConfirm.vue';
import OfferInfo from '@/components/OfferInfo.vue';
import offerMixin from '@/views/mixins/offer';
import offerTemplate from './helper/offer-template';

export default {
  name: 'AffiliateOffersNew',
  components: {
    AddOfferPopup,
    OfferDeleteConfirm,
    PendingChanges,
    OfferInfo,
  },
  filters: {
    notSet(v, tr) {
      if (v === 0) {
        return tr('affiliates.affiliatesOffers.not_set');
      }
      return v;
    },
  },
  emits: ['update:info'],
  mixins: [offerMixin],
  data() {
    return {
      currentOfferCardBrand: '',
      changesEffTimestampPopover: [],
      affiliateId: '',
      customerCurrencies: [],
      linksOfferPermissions: {},
      isCatalogOfferSelectOpen: false,
      data: {},
      wallets: {},
      isOffersVisible: false,
      permissions: {},
      action: '',
      isPopupOpen: false,
      isPendingPopupOpen: false,
      offerInfo: {},
      isActiveOfferCard: 0,
      offerRequests: [],
      affiliateOffersList: [],
      isOfferLoadingForPopup: true,
      isDataLoading: true,
      isOfferLoading: false,
      isOfferReqLoading: false,
      isLoadingOfferInfo: false,
      offersCatalog: [],
      selectedOffer: null,

      searchText: '',
      info: {},
      // popup confirm
      confirmMsg: '',
      confirmAction: '',
      confirmTitle: '',
      confirmType: '',
      actionName: '',
      actionFaIcon: '',
      actionIcon: '',
      isPopupOpenConfirm: false,
      loadingBtn: false,
      loadingBtnConfirm: false,
      offerId: '',
    };
  },
  watch: {
    isCatalogOfferSelectOpen(value) {
      const selectRef = this.$refs?.select_link_catalog?.$refs?.uiSelectElement;

      if (selectRef) {
        if (value) {
          selectRef.toggleMenu();
        } else {
          selectRef.blur();
        }
      }
    },
  },
  computed: {
    offersCatalogGrouped() {
      return Object.values(this.offersCatalog.reduce((acc, offer) => {
        const categoryId = offer.category_id;
        const categoryName = offer.category_name;

        if (!acc[categoryId]) {
          acc[categoryId] = {
            category_id: categoryId,
            category_name: categoryName,
            offers: [],
          };
        }
        acc[categoryId].offers.push(offer);
        return acc;
      }, {}));
    },
    defaultCurrency() {
      return this.wallets.currency_code || 'USD';
    },
    isCreateOfferCustom() {
      return this.permissions.edit_offers_custom;
    },
    isCreateOfferLinkedToCatalog() {
      return this.permissions.edit_offers_linked_to_catalog;
    },
    isEditOffer() {
      return !!(this.offerInfo.cataloged_affiliate_offer_id
        ? this.linksOfferPermissions.edit_linked_to_catalog
        : this.linksOfferPermissions.edit_custom);
    },
    isDeleteOffer() {
      return !!this.linksOfferPermissions.delete;
    },
  },

  async mounted() {
    this.$eventBus.$on('checkUnpin', this.checkUnpin);
    this.$eventBus.$on('editOffer', this.editOffer);

    this.affiliateId = this.$route.params.id;
    if (!this.affiliateId) {
      this.$router.push('/affiliates/list');
    }
    try {
      await this.getOffersCatalog();
      const { data } = await this.$api.getAffiliateInfo(this.affiliateId);
      this.info = data.payload;
      this.permissions = data.misc.permissions;

      if (this.permissions.edit_offers) {
        this.$api.getMiscCustomerCurrencies().then((res) => {
          this.customerCurrencies = res.data.payload;
        });
      }
      await this.getOffers();
      await this.fetchWallets();
    } finally {
      this.isDataLoading = false;
    }
  },

  beforeUnmount() {
    this.$eventBus.$off('checkUnpin', this.checkUnpin);
    this.$eventBus.$off('editOffer', this.editOffer);
  },

  methods: {
    openLinkCatalogSelect() {
      this.isCatalogOfferSelectOpen = !this.isCatalogOfferSelectOpen;
    },
    async fetchWallets() {
      const response = await this.$api.getAffiliateWallets(this.affiliateId);

      this.wallets = response.data.payload.find((wallet) => wallet.status === 'active');
    },

    linkOffer(offer) {
      this.isCatalogOfferSelectOpen = false;
      this.addOffer({ ...offer, cataloged_affiliate_offer_id: offer.id });
    },

    getOffersCatalog() {
      return this.$api.getAffiliateOffersCatalog().then((res) => {
        this.offersCatalog = res.data.payload;
      });
    },

    async getOffers(isSetLastAddedIndex = false) {
      this.isDataLoading = true;
      this.isOfferLoading = false;
      try {
        const { data } = await this.$api.getAffiliateOffers(this.affiliateId);
        this.affiliateOffersList = data.payload;
        if (this.affiliateOffersList.length !== 0) {
          if (isSetLastAddedIndex) {
            this.onSetActiveLastAddedOffer();
          }
          await this.activeOffer(
            this.affiliateOffersList[this.isActiveOfferCard].id,
            this.isActiveOfferCard,
          );
        }
        this.changesEffTimestampPopover = new Array(
          this.affiliateOffersList.length,
        ).fill(false);
        return data;
      } finally {
        this.isDataLoading = false;
        this.isOfferLoading = true;
      }
    },

    async activeOffer(offerId, count) {
      try {
        this.isOfferLoadingForPopup = true;
        const response = await this.$api.getAffiliateOffer(offerId);
        this.isActiveOfferCard = count;
        this.searchText = '';
        this.offerInfo = {
          ...this.$_.cloneDeep(response.data.payload),
          payout_rules: this.$_.cloneDeep(response.data.payload).payout_rules.map((elem) => ({
            ...elem,
            settings: {
              ...elem.settings,
              rev_share: elem.settings.rev_share ? {
                sport_levels: elem.settings.rev_share.sport_levels,
                casino_levels: this.$_.isEqual(elem.settings.rev_share.sport_levels, elem.settings.rev_share.casino_levels)
                  ? null : elem.settings.rev_share.casino_levels,
              } : null,
              cpa: elem.settings.cpa?.map(this.genCpaParams) || null,
            },
          })),
        };
        this.linksOfferPermissions = response.data.misc.permissions;
      } catch (error) {
        this.errors = this.$_.cloneDeepWith(error.data.errors);
      } finally {
        this.isOfferLoadingForPopup = false;
      }
    },

    addOffer(offer = offerTemplate) {
      this.action = 'Add';
      this.editOfferPopup(offer);
    },

    updateInfo(isSetLastAddedIndex = false) {
      this.getOffers(isSetLastAddedIndex);
      this.$api.getAffiliateInfo(this.affiliateId).then((response) => {
        this.$emit('update:info', this.$_.cloneDeepWith(response.data.payload));
      });
    },

    onSetActiveLastAddedOffer() {
      const lastAdded = this.affiliateOffersList.reduce((acc, list, index) => {
        if (!acc.incrementing_id || list.incrementing_id > acc.incrementing_id) {
          return {
            ...list,
            index,
          };
        }
        return acc;
      }, {});

      this.isActiveOfferCard = lastAdded.index;
    },
    onClosePopup(action, isLastAdded) {
      this.isPopupOpen = false;
      if (action === 'Add') {
        this.isActiveOfferCard = this.affiliateOffersNew?.length || 0;
      }
      this.updateInfo(isLastAdded);
    },

    cancelScheduledChanges(id, flag) {
      return this.$api.cancelScheduledChanges(id).then(() => {
        this.getOffers().finally(() => {
          this.$refs.confirm.close();
          this.loadingBtnConfirm = false;
          if (flag === 'del') {
            setTimeout(() => {
              document.querySelector('#app').classList.remove('offer-ovf');
              this.editOffer();
            });
          }
        });
      });
    },
    // /popup confirm
    pendingChangesPopup() {
      this.isPendingPopupOpen = true;
    },
    onClosePendingPopup() {
      this.isPendingPopupOpen = false;
    },
    onClosePopupConfirm() {
      this.isPopupOpenConfirm = false;
      this.updateInfo();
    },

    deleteOffer(v, type, nameNewOffer) {
      this.offerId = v;
      this.onConfirm(type, nameNewOffer);
    },

    onConfirm(type, nameNewOffer) {
      if (type === 'confirm') {
        this.confirmTitle = `${this.$t(
          'affiliates.affiliateSub.confirm.title_7',
          {
            subAffiliateEmail: this.offerInfo.name,
            affiliateEmail: this.info.email,
          },
        )}`;
        this.confirmMsg = `${this.$t('affiliates.affiliateSub.confirm.msg_7', {
          subAffiliateEmail: this.offerInfo.name,
          affiliateEmail: this.info.email,
          offer: nameNewOffer,
        })}`;
        this.actionName = `${this.$t(
          'affiliates.affiliateSub.confirm.action_7',
        )}`;
        this.confirmAction = '';
        this.confirmType = 'warning';
        this.actionFaIcon = 'unlink';
        this.$refs.confirm.open();
      }
      if (type === 'unpin') {
        this.confirmTitle = `${this.$t(
          'affiliates.affiliateSub.confirm.title_6',
          {
            subAffiliateEmail: this.offerInfo.name,
            affiliateEmail: this.info.email,
          },
        )}`;
        this.confirmMsg = `${this.$t('affiliates.affiliateSub.confirm.msg_6', {
          subAffiliateEmail: this.offerInfo.name,
          affiliateEmail: this.info.email,
        })}`;
        this.actionName = `${this.$t(
          'affiliates.affiliateSub.confirm.action_6',
        )}`;
        this.confirmAction = '';
        this.confirmType = 'warning';
        this.actionFaIcon = 'unlink';
        this.$refs.confirm.open();
      }
    },

    closeConfirmHandler(action) {
      if (action !== undefined) {
        setTimeout(() => {
          document.querySelector('#app').classList.remove('offer-ovf');
        }, 200);
      }
    },

    confirmHandler(action) {
      if (action === 'pending') {
        this.loadingBtnConfirm = true;
        this.cancelScheduledChanges(this.offerInfo.id, 'del');
      } else {
        this.unpinOffer();
      }
    },

    editOffer(v) {
      if (v) {
        document.querySelector('#app').classList.add('offer-ovf');
        this.confirmTitle = `${this.$t(
          'affiliates.affiliatesOffers.edit_offer_title',
        )}`;
        this.confirmMsg = `${this.$t(
          'affiliates.affiliatesOffers.edit_offer_msg',
        )}`;
        this.actionName = `${this.$t(
          'affiliates.affiliatesOffers.edit_offer_action',
        )}`;
        this.confirmAction = 'pending';
        this.confirmType = 'success';
        this.actionFaIcon = 'check';
        this.$refs.confirm.open();
      } else {
        this.action = 'Edit';
        this.isPopupOpen = true;
        this.data = this.offerInfo;
      }
    },

    editOfferPopup(item) {
      this.action = 'Add';
      this.isPopupOpen = true;
      let itemNew = item;
      const settings = item.template_settings;
      itemNew = this.$_.merge(itemNew, settings);

      // add default currency code USD
      itemNew.payout_rules = itemNew.payout_rules.map((r) => ({
        ...r,
        settings: {
          ...r.settings,
          rev_share: r.settings.rev_share ? {
            sport_levels: r.settings.rev_share.sport_levels,
            casino_levels: this.$_.isEqual(r.settings.rev_share.sport_levels, r.settings.rev_share.casino_levels)
              ? null : r.settings.rev_share.casino_levels,
          } : null,
          cpa: r.settings?.cpa?.map((cpa) => ({
            currency_code: this.defaultCurrency,
            ...cpa,
          }))?.map(this.genCpaParams) || null,
        },
      }));

      if (
        this.$store.getters['auth/currentAcl'].offers_revshare_edit_settings !== 'allow' && localStorage.getItem('active-team')
      ) {
        itemNew.payout_rules[0].settings.rev_share.sport_levels = null;
        itemNew.payout_rules[0].settings.rev_share.casino_levels = null;
      }

      delete itemNew.template_settings;
      this.data = itemNew;
    },

    checkUnpin() {
      this.loadingBtn = true;
      this.$api
        .getAffiliateOfferBeforeDelete(this.offerInfo.id)
        .then((res) => {
          const removeAllowed = res.data.payload.need_to_set_new_offer;
          if (removeAllowed) {
            this.isPopupOpenConfirm = true;
          } else {
            this.onConfirm('unpin');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },

    unpinOffer() {
      const q = {
        new_affiliate_offer_id: this.offerId,
      };
      this.isDataLoading = true;
      this.$api.unpinAffiliateOffer(this.offerInfo.id, q).then(() => {
        this.isActiveOfferCard = 0;
        this.$refs.confirm.close();
        this.isPopupOpenConfirm = false;
        this.offerId = '';
        this.updateInfo();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chevron {
  font-weight: 800!important;
  font-size: 10px;
  color: var(--charcoal);
}

.links-offer-wrapper {
  border-radius: 3px;
  max-height: 300px;
  overflow-y: auto;
  font-size: 14px;
  color: var(--charcoal);
}

.offer-select {
  width: 100%;

  .el-select {
    width: 100%;
  }
}

.links-offer {
  display: flex;
  align-items: center;
  width: 358px;
  height: 34px;
  padding-left: 19px;

  div {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &:hover {
    background-color: rgba(32, 129, 94, 0.1);
    cursor: pointer;
  }
}

.affiliate-offers {
  padding-bottom: 44px;

  .add-offer-popup{
    .el-checkbox{
      margin-right: 0;
    }
  }

  .msg {
    padding-top: 40px;
    width: 100%;
    text-align: center;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    //min-width: 1140px;
    //width: 90%;
  }
}

.links-catalog-offer__header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.links-catalog-offer__select {
  position: relative;
}
.links-catalog-offer__select_hidden {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
}
</style>

<style lang="scss">
.affiliate-offers-new__confirm{
  .wrapper .body__wrap i{
    margin-right: 12px;
  }
}
.links-offer-poppover {
  padding: 0!important;
}
</style>
